<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="part01"><a id="page_7"></a><strong>Part 1</strong></h2>
<div class="blockquote">
<p class="noindent">Forgiveness is based on the fact that there is no adequate form of revenge.</p>
<p class="right">C<span class="small">HARLES</span> N<span class="small">EWMAN</span></p>
</div>
<p class="noindent"><a id="page_8"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?035076ab